module.exports = __webpack_public_path__ + "static/media/marker-highlighted.d5bafb1a.svg";